// extracted by mini-css-extract-plugin
export default {"infoIcon":"V8Mjor"};